import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Subscribable } from '../../../../../models/base/subscribable';
import { EmploymentDetailsFormGroup } from '../../../../../forms/employment-details-form-group';
import { LeaveDetailsType } from '../../../../../models/employers/employer-history/types/leave-details-type';
import { DropDownItem } from '../../../../../models/shared/stylesheet/drop-down-item';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { isoDateStringValidator } from '../../../../../validators/iso-date-string-validator';
import { EmploymentType } from '../../../../../models/employers/employer-history/types/employment-type';
import { State } from '../../../../../models/types/dto/state';

@Component({
  selector: 'app-employment-details-form-grid',
  templateUrl: './employment-details-form-grid.component.html',
  styleUrls: ['./employment-details-form-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmploymentDetailsFormGridComponent extends Subscribable implements OnChanges, OnInit {
  @Input() form!: EmploymentDetailsFormGroup;
  @Input() formSubmitted = false;
  @Input() leaveTypes: LeaveDetailsType[] = [];
  @Input() provinces: State[] = [];
  @Input() employmentTypes: EmploymentType[] = [];

  public leaveTypeDropdowns: DropDownItem[] = [];
  public employmentTypeDropdowns: DropDownItem[] = [];
  public provinceDropdowns: DropDownItem[] = [];

  public yesNoDropdowns = [new DropDownItem($localize`Yes`, true), new DropDownItem($localize`No`, false)];

  public customErrorMessages = {
    startDate: {
      required: $localize`Employment start date required`
    },
    contributionStartDate: {
      required: $localize`Contribution start date required`
    },
    employmentTypeId: {
      required: $localize`Employment type required`
    },
    provinceOfEmploymentId: {
      required: $localize`Province of employment required`
    },
    workFromHome: {
      required: $localize`Work from home status required`
    },
    onLeave: {
      required: $localize`On leave information required`
    },
    leaveTypeId: {
      required: $localize`Leave type required`
    },
    leaveStart: {
      required: $localize`Leave start date required`
    },
    expectedReturnDate: {
      required: $localize`Expected return date required`
    },
    continuedContributions: {
      required: $localize`Continued contribution information required`
    }
  };

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.leaveTypes) {
      this.leaveTypeDropdowns = this.leaveTypes?.map(lt => new DropDownItem(lt.name, lt.id)) ?? [];
    }
    if (changes.employmentTypes) {
      this.employmentTypeDropdowns = this.employmentTypes?.map(et => new DropDownItem(et.name, et.id)) ?? [];
    }
    if (changes.provinces) {
      this.provinceDropdowns = this.provinces?.map(p => new DropDownItem(p.name, p.id)) ?? [];
    }
  }

  public ngOnInit() {
    this.form.controls.onLeave.valueChanges.subscribeWhileAlive({
      owner: this,
      next: value => {
        if (value) {
          this.form.addControl(
            'leaveDetails',
            new FormGroup({
              leaveTypeId: new FormControl<number | null>(null, { validators: [Validators.required] }),
              startDate: new FormControl<string | null>(null, {
                validators: [Validators.required, isoDateStringValidator]
              }),
              expectedReturnDate: new FormControl<string | null>(null, {
                validators: [Validators.required, isoDateStringValidator]
              }),
              continuedContributions: new FormControl<boolean | null>(null, { validators: [Validators.required] })
            })
          );
        } else {
          this.form.removeControl('leaveDetails');
        }
      }
    });
  }
}
